module.exports = __webpack_public_path__ + "img/teaser_search-1440x560.de0dc33.jpg";